export enum WorkflowConfigType {
    TECHNICAL_WORKFLOW = 'TechnicalWorkflow',
    COMMERCIAL_WORKFLOW = 'CommercialWorkflow'
}
